import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import DropzoneS3Uploader from "react-dropzone-s3-uploader";
import UUID from "uuid/v4";
import Loader from "react-loader-advanced";
import CircularProgress from "material-ui/CircularProgress";
import ReactS3Uploader from "react-s3-uploader";

import Config from "../../config";
import { createRequestOptions } from "../../services/utils";
import events from "../../services/events";
import colors from "../../styles/colors";
import "../../resources/styles/VideoPicker.css";
import { StyledDropZone } from "react-drop-zone";
import S3Upload from "react-s3-uploader/s3upload.js";
import Delete from "material-ui/svg-icons/action/delete-forever";
import { IconButton } from "@material-ui/core";
import { isMobile } from "react-device-detect";
import { ThreeDRotationSharp } from "@material-ui/icons";

const style = {
  container: {
    margin: 10,
    display: "flex",
    flexFlow: "row",
  },
  header: {
    margin: 5,
    fontSize: 16,
    color: colors.primary,
    fontFamily: "Poppins-Regular",
  },
  text: {
    fontSize: 12,
    color: colors.primary,
    fontFamily: "Poppins-Regular",
    margin: 0,
  },
};

class VideoPicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      videoUrl: !_.isEmpty(props.videoUrl) ? props.videoUrl : "",
      isUploading: false,
      progress: 0,
      error: "",
    };

    this.preprocess = this.preprocess.bind(this);
    this.getFileNameForType = this.getFileNameForType.bind(this);
    this.getSignedUrl = this.getSignedUrl.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.onProgress = this.onProgress.bind(this);
    this.onClear = this.onClear.bind(this);
    this.onError = this.onError.bind(this);
    this.onFinish = this.onFinish.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEmpty(nextProps.videoUrl)) {
      this.setState({
        videoUrl: nextProps.videoUrl,
      });
    }
  }

  getFileNameForType(file) {
    let fileName = "";
    if (this.props.videoType === "library") {
      fileName = `raw/l_${this.props.appId}_library_${UUID()}.mp4`;
    } else if (this.props.videoType === "custom") {
      fileName = `raw/c_${this.props.appId}_${
        this.props.customAppId
      }_${UUID()}.mp4`;
    } else {
      fileName =
        "videos/" +
        this.props.userId +
        "/" +
        this.props.appId +
        "/" +
        UUID() +
        ".mp4";
    }
    return fileName;
  }

  getSignedUrl(file, callback) {
    let fileName = this.getFileNameForType(file);
    let userId = this.props.userId;
    let bucketName = Config.s3.bucket;
    let objectKey = fileName;
    let contentType = file.type;
    const options = createRequestOptions({
      userId,
      bucketName,
      objectKey,
      contentType,
    });
    fetch(Config.serverUrl + "/GetS3SignedUrl", options)
      .then((response) => response.json())
      .then((responseJson) => {
        let ret = _.get(responseJson, "response");
        let signedUrl = _.replace(ret.signedUrl, "http://", "https://");
        let result = {
          signedUrl,
          fileName,
          publicUrl: "/s3/uploads/" + fileName,
          fileKey: fileName,
        };
        callback(result);
      })
      .catch((error) => {
        console.error("Error getting signed url: " + error);
        this.setState({
          isUploading: false,
          error: "Error uploading the video: internal error",
        });
      });
  }

  async uploadFile(file) {
    let fileName =
      "videos/" + this.props.userId + "/" + this.props.appId + "/" + UUID();

    if (file.type === "video/mp4") {
      fileName += ".mp4";
    } else if (file.type === "video/quicktime") {
      fileName += ".mov";
    }

    this.setState({ fileName: fileName });

    let upload = new S3Upload({
      files: [file],
      getSignedUrl: this.getSignedUrl,
      onProgress: this.onProgress,
      onFinishS3Put: this.onFinish,
    });
  }

  // preprocess
  preprocess(file, next) {
    if (file.size > 150000000) {
      this.setState({
        isUploading: false,
        error: "Video is too big. Please choose a video under 150M.",
      });
    } else {
      this.setState({
        error: "",
      });
      return next(file);
    }
  }

  // Progress
  onProgress(percent, message) {
    this.setState({ progress: percent });
    if (!this.state.isUploading && percent < 100) {
      this.setState({ isUploading: true });
    }
  }

  // error
  onError(message) {
    this.setState({
      isUploading: false,
      error: "Error uploding the video: " + message,
    });
  }

  onClear() {
    if (this.props.clearVideo) {
      this.setState({
        videoUrl: null,
        isUploading: false,
        progress: 0,
      });
      this.props.clearVideo();
    }
  }

  // finish
  onFinish(data) {
    let videoUrl = Config.s3.s3Url + "/" + data.fileName;
    this.setState({
      isUploading: false,
      videoUrl,
    });
    this.props.handleSubmit(videoUrl);
  }

  videoOnEnded() {
    if (this.props.libraryApp) {
      events().trackUserEvent(
        "Video Watched Until End",
        this.props.libraryApp.appId,
        null,
        this.props.libraryInstruction
          ? this.props.libraryInstruction.categoryId
          : null,
        null,
        this.props.userId,
        null,
        "portal",
        this.props.libraryApp.appName,
        this.props.libraryInstruction
          ? this.props.libraryInstruction.categoryName
          : null,
        JSON.stringify({
          type: "Library Instruction",
        })
      );
    }
  }

  videoOnPlay() {
    console.log("PROPS", this.props);

    if (this.props.libraryApp) {
      events().trackUserEvent(
        "Video Watched",
        this.props.libraryApp.appId,
        null,
        this.props.libraryInstruction
          ? this.props.libraryInstruction.categoryId
          : null,
        null,
        this.props.userId,
        null,
        "portal",
        this.props.libraryApp.appName,
        this.props.libraryInstruction
          ? this.props.libraryInstruction.categoryName
          : null,
        JSON.stringify({
          type: "Library Instruction",
        })
      );
    }
  }

  isValidVideoUrl() {
    const { videoUrl } = this.state;
    const base =
      "https://user-image-storage.s3.amazonaws.com/compressed/video/";
    return (
      !_.isEmpty(videoUrl) &&
      (!videoUrl.startsWith(base) ||
        videoUrl.substring(base.length).split("?")[0].trim() !== "")
    );
  }

  render() {
    return (
      <div>
        {(() => {
          const { videoUrl } = this.state;
          const base =
            "https://user-image-storage.s3.amazonaws.com/compressed/video/";
          const isValid =
            !_.isEmpty(videoUrl) &&
            (!videoUrl.startsWith(base) ||
              videoUrl.substring(base.length).split("?")[0].trim() !== "");

          if (!isValid) {
            // Show video picker if invalid
            return (
              <div className={"video-picker-box"}>
                <Loader
                  show={this.state.isUploading}
                  message={
                    <div>
                      <div style={{ marginBottom: 30 }}>
                        Uploading Video... Progress: {this.state.progress}%
                      </div>
                      <CircularProgress
                        mode="determinate"
                        value={this.state.progress}
                      />
                    </div>
                  }
                  className={"full-size"}
                >
                  {!this.state.isUploading && !!!isMobile && (
                    <StyledDropZone
                      onDrop={(file, text) => this.uploadFile(file)}
                      accept="video/*"
                      className={"video-picker-box-dropzone"}
                    >
                      <h3 style={style.header}>Upload Video File</h3>
                      <p style={style.text}>
                        Drag and Drop Video File or <u>Click HERE to Browse</u>
                        <p>
                          Supported video file types include: .ogm, .wmv, .mpg,
                          .webm, .ogv, .mov, .asx, .mpeg, .mp4, .m4v, and .avi.
                        </p>
                      </p>
                    </StyledDropZone>
                  )}
                  {!this.state.isUploading && !!isMobile && (
                    <div style={{ width: "100%", textAlign: "center" }}>
                      <h3 style={style.header}>Upload Video File</h3>
                      <p style={style.text}>Select a video to upload</p>
                      <input
                        type="file"
                        accept="video/*"
                        onChange={(event) => {
                          this.uploadFile(event.target.files[0]);
                        }}
                      />
                    </div>
                  )}
                </Loader>
              </div>
            );
          }

          // Show video player if valid
          return (
            <div
              style={{
                backgroundColor: "black",
                position: "relative",
                height: 250,
                width: 400,
                marginLeft: "auto",
                marginRight: "auto",
                zIndex: 1,
              }}
            >
              <video
                key={videoUrl}
                className="video-playback"
                data-reactid=".0.1.0.0"
                controls={true}
                style={{
                  height: 250,
                  width: 400,
                  backgroundColor: "black",
                }}
                onPlay={() => {
                  this.videoOnPlay();
                }}
                onEnded={() => {
                  this.videoOnEnded();
                }}
              >
                <source src={videoUrl} type="video/mp4" />
              </video>
              <IconButton
                style={{
                  position: "absolute",
                  top: 5,
                  right: 5,
                  border: "solid 1px black",
                  backgroundColor: "#fafafa",
                  zIndex: 99,
                }}
                onClick={this.onClear}
              >
                <Delete />
              </IconButton>
            </div>
          );
        })()}
      </div>
    );
  }
}

VideoPicker.propTypes = {
  videoUrl: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
  appId: PropTypes.string.isRequired,
};

export default VideoPicker;



// WEBPACK FOOTER //
// ./src/components/common/VideoPicker.js